import React, { useState } from "react";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { useFeed } from "../context/FeedContext";
import { pageColors } from "../mock";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CreatorsRoom = () => {
  const navigate = useNavigate();
  const { current } = useAuth();
  const { creators, postCreator } = useFeed();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => { document.title = "TMM|CREATORS ROOM"; }, []);

  if (!current) {
    return (
      <>
        <Header hoverColor={pageColors.contact} compact={false} />
        <div className="gated-page">
          <h1>Members only</h1>
          <p>The Creators Room is open to signed-in members.</p>
          <Link to="/members" className="btn-solid">Go to Members</Link>
        </div>
      </>
    );
  }

  const post = async (e) => {
    e.preventDefault();
    setErr("");
    if (!body.trim()) {
      setErr("Write something before posting.");
      return;
    }
    setBusy(true);
    const r = await postCreator({ title, body });
    setBusy(false);
    if (!r.ok) {
      setErr(r.error);
      return;
    }
    setTitle("");
    setBody("");
  };

  return (
    <>
      <Header hoverColor={pageColors.contact} compact={false} />
      <div className="feed-page">
        <button
          type="button"
          className="feed-back"
          onClick={() => navigate("/members")}
          data-testid="creators-back-btn"
        >
          <ArrowLeft size={16} /> Back to Members
        </button>

        <header className="feed-hero">
          <h1 className="feed-title">CREATORS ROOM</h1>
          <p className="feed-sub">Post what you're making, thinking, arguing. Signed-in members only.</p>
        </header>

        <form className="feed-composer" onSubmit={post}>
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Optional title…" data-testid="creators-title" />
          <textarea rows={4} value={body} onChange={(e) => setBody(e.target.value)} placeholder="What's on your mind?" data-testid="creators-body" />
          {err && <div className="auth-error" data-testid="creators-error">{err}</div>}
          <button type="submit" className="btn-solid" disabled={busy} data-testid="creators-submit">
            {busy ? "…" : "Post to the room"}
          </button>
        </form>

        <div className="feed-list">
          {creators.length === 0 && <div className="feed-empty">No posts yet. Start the conversation.</div>}
          {creators.map((p) => (
            <article key={p.id} className="feed-item">
              <div className="feed-item-avatar">
                {p.authorAvatar
                  ? <img src={p.authorAvatar} alt="" />
                  : <div className="feed-item-avatar-fallback">{(p.authorName || "?")[0]}</div>}
              </div>
              <div className="feed-item-body">
                <div className="feed-item-meta">
                  <span className="feed-item-author">{p.authorName}</span>
                  <span className="feed-item-ts">{new Date(p.ts).toLocaleString()}</span>
                </div>
                {p.title && <h3 className="feed-item-title">{p.title}</h3>}
                <p className="feed-item-text">{p.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default CreatorsRoom;
